import styles from '@styles/scss/list/_modelGrid.module.scss';
import { Banner } from 'lib/types/item/banner';
import { PerformerCard } from 'lib/types/item/performerCard';

import BannerCTA from '../common/bannerCTA';
import Card from '../performer/card';

export default function AdvancedModelGrid({
    performerCards,
    banner,
    currentLang
}: {
    performerCards: PerformerCard[];
    banner: Banner;
    currentLang: string;
}): JSX.Element {
    return (
        <div className={styles.performersContainer}>
            <h1 className={styles.advancedSearchH1}>Advanced Search Results</h1>
            <div className={styles.performers}>
                {performerCards.slice(0, 12).map((performer) => (
                    <div key={performer.username} className={styles.performer}>
                        <Card
                            key={performer.username}
                            performerCard={performer}
                            currentLang={currentLang}
                            gender="girls"
                            randomNumber={15} // number that won't trigger autoplay
                            index={0}
                            currentlyHovered={false}
                        />
                    </div>
                ))}
            </div>
            <BannerCTA
                banner={banner}
                currentLang={currentLang}
                bannerText=""
                Ecategory="Outbound Click"
                Eaction="Join Click"
                Elabel1="Floating-CTA2"
                Elabel2="Floating-Text2"
                gender="girls"
            />
            <div className={styles.performers}>
                {performerCards.slice(12, 24).map((performer) => (
                    <div key={performer.username} className={styles.performer}>
                        <Card
                            key={performer.username}
                            performerCard={performer}
                            currentLang={currentLang}
                            gender="girls"
                            randomNumber={15} // number that won't trigger autoplay
                            index={0}
                            currentlyHovered={false}
                        />
                    </div>
                ))}
            </div>
            <BannerCTA
                banner={banner}
                currentLang={currentLang}
                bannerText={banner.text_2nd_block}
                Ecategory="Outbound Click"
                Eaction="Join Click"
                Elabel1="Floating-CTA2"
                Elabel2="Floating-Text2"
                gender="girls"
            />
            <div className={styles.performers}>
                {performerCards.slice(24, 36).map((performer) => (
                    <div key={performer.username} className={styles.performer}>
                        <Card
                            key={performer.username}
                            performerCard={performer}
                            currentLang={currentLang}
                            gender="girls"
                            randomNumber={15} // number that won't trigger autoplay
                            index={0}
                            currentlyHovered={false}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
